/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck
import '../../../../assets/styles/bootstrap.min.scss'
import '../../../../assets/styles/formio.full.scss'

import { Form } from '@formio/react'
import { Avatar, Box, Button } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import ExcelLogo from '../../../../assets/images/learnstage-logo.png'
import { SurveyList } from '../../../../assets/Svg/Index'
import { ROUTES } from '../../../../helpers/constants'
import { noop } from '../../../../helpers/utils'
import withRedirect from '../../../../hocs/RedirectHOC'
import SurveyConfirmationModal from './SurveyConfirmationModal'

function CustomSurvey({
  school,
  surveysDetails,
  handleFormSubmit,
  isSurveySubmitted,
  onCloseConfirm,
}) {
  const { t } = useTranslation()

  const onSubmit = (submission) => {
    handleFormSubmit(submission.data)
  }

  const ButtonEnhanced = withRedirect(Button)
  return (
    <>
      <Box
        px={3}
        display="flex"
        alignItems="flex-start"
        justifyContent="flex-start"
        flexDirection="column"
      >
        <Box
          width="100%"
          flexGrow={0}
          display="flex"
          alignItems="center"
          justifyContent={{ xs: 'center', md: 'space-between' }}
          flexDirection="row"
          px={0}
          py={2}
          className="allProgmResvi-between"
        >
          <Box className="brand-logo">
            <img
              src={school.sch_logo || ExcelLogo}
              alt="Logo"
              onError={(e) => {
                e.target.onerror = null
                e.target.src = ExcelLogo
              }}
            />
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            flexDirection="row"
            fontWeight="fontWeightMedium"
            fontSize="14px"
          >
            <ButtonEnhanced
              className="custom-default-button text-transform-none"
              variant="contained"
              disableElevation
              to={ROUTES.LOGIN}
            >
              {t('cancel')}
            </ButtonEnhanced>
          </Box>
        </Box>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        width="100% "
        minHeight="calc(100vh - 92px)"
        pb={2}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          bgcolor={'var(--color-blue-grey-10)'}
          width={{ xs: '100% ', sm: '600px', md: '960px', lg: '1200px' }}
          borderRadius="16px"
          p={3}
        >
          <Box
            display="flex"
            alignItems="center"
            component="div"
            mb={2}
            width="100%"
            gridGap="16px"
          >
            <Box
              width={64}
              height={64}
              bgcolor="var(--color-primary-light-20)"
              color="var(--color-primary-dark)"
              borderRadius="8px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {surveysDetails?.media?.media_doc_name ? (
                <Avatar
                  src={surveysDetails?.media?.media_doc_name}
                  alt={'survey image'}
                  tabIndex={0}
                  variant="rounded"
                  style={{
                    width: '64px',
                    height: '64px',
                  }}
                />
              ) : (
                <SurveyList />
              )}
            </Box>
            <Box
              display="flex"
              alignItems="flex-start"
              flexDirection="column"
              component="div"
              color="textSecondary"
              fontSize={16}
              width={'calc(100% - 64px)'}
            >
              <Box component="span" fontWeight="fontWeightBold" fontSize="1.5rem" mr={1}>
                {surveysDetails.sr_title}
              </Box>
              <Box
                fontSize={14}
                fontWeight={400}
                color="var(--color-grey-4)"
                className="word-break white-space-normal"
              >
                {surveysDetails.sr_description}
              </Box>
            </Box>
          </Box>
          <Box width="100%" display="block" className="create-form">
            {/* <SurveyConfirmationModal /> */}
            <Form form={surveysDetails.sr_content} onSubmit={onSubmit} />
          </Box>
        </Box>
      </Box>
      {isSurveySubmitted ? (
        <SurveyConfirmationModal open={isSurveySubmitted} onClose={onCloseConfirm} />
      ) : null}
    </>
  )
}
CustomSurvey.propTypes = {
  school: PropTypes.object,
  surveysDetails: PropTypes.object,
  handleFormSubmit: PropTypes.func,
  isSurveySubmitted: PropTypes.bool,
  onCloseConfirm: PropTypes.func,
}

CustomSurvey.defaultProps = {
  school: {},
  readOnlyMode: false,
  surveysDetails: {},
  handleFormSubmit: noop,
  isSurveySubmitted: false,
  onCloseConfirm: noop,
}

export default CustomSurvey
